import { z } from "zod";

/**
 * ChecklistItemSchema - Individual checklist item
 */
const ChecklistItemSchema = z.object({
  id: z.string(),
  text: z.string(),
  checked: z.boolean(),
  category: z.string().optional(),
}).strict();

/**
 * ChecklistNodeSchema - Content Schema for Checklist Investment Node
 *
 * Checklist nodes track investment-related checklists and action items.
 *
 * Field naming convention:
 * - items: Array of checklist items (with id, text, checked, category)
 * - title: Optional checklist title
 * - templateId: Optional template ID for checklist templates
 */
export const ChecklistNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("checklist"),
  version: z.literal(1),
  key: z.string(),

  // Business data
  items: z.array(ChecklistItemSchema),
  title: z.string().optional(),
  templateId: z.string().optional(),
}).strict();

export type ChecklistNode = z.infer<typeof ChecklistNodeSchema>;
export type ChecklistItem = z.infer<typeof ChecklistItemSchema>;
